import { LOGIN_TYPE_ADMLIMITED } from "Constants";
import {
  STORE_KEY_LIST,
  STORE_KEY_LOGIN_TYPE,
  fromUTCtoZoneFormatted,
  storeGet,
} from "mailup-react-helpers";
import { notifyParent } from "mailup-react-helpers";
import {
  Actions,
  Badge,
  Checkbox,
  DataListExtraColumn,
  DataListRow,
  Grid,
  GridCell,
  Text,
  TruncateAndTooltip,
} from "mailup-web-components";
import React, { type FC } from "react";
import { useIntl } from "react-intl";
import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil";
import { EXTRA_COLUMN_AFTER_WIDTH } from "../model";
import {
  downloadImportFileCallback,
  toggleSelectRecipientCallback,
} from "../recoil/callbacks";
import {
  isRecipientSelected,
  isSelectRecipientDisabled,
  modalDelesteImpostsState,
} from "../recoil/state";

interface ImportedTableRowProps {
  item: any;
}

const ImportedTableRow: FC<ImportedTableRowProps> = ({ item }) => {
  const intl = useIntl();
  const { TimeZoneCode } = storeGet(STORE_KEY_LIST);
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE);
  const checked = useRecoilValue(isRecipientSelected(item.Id));
  const disabled = useRecoilValue(isSelectRecipientDisabled);
  const toggleSelectRecipient = useRecoilCallback(
    toggleSelectRecipientCallback,
    [],
  );
  const setModalDelete = useSetRecoilState(modalDelesteImpostsState);
  const downloadImportFile = useRecoilCallback(downloadImportFileCallback, []);

  function onClickDownload() {
    downloadImportFile(item.Filename, item.Id);
  }

  function onClickDelete() {
    setModalDelete((_prev) => ({
      show: true,
      title: intl.formatMessage(
        {
          id: "Load.FileImportStatus.ModalDeleteSingleTitle",
        },
        {
          NAME: item.Filename,
        },
      ),
      descr: intl.formatMessage({
        id: "Load.FileImportStatus.ModalDeleteDescr",
      }),
      id: item.Id,
      source: "tableImported",
    }));
  }

  function onClickDetails() {
    notifyParent("redirectMainFrame", [
      `Import_Details.aspx?idImport=${item.Id}`,
    ]);
  }

  function setItemsAction() {
    const itemsAction = [];
    itemsAction.push({
      label: intl.formatMessage({
        id: "Load.FileImportStatus.DetailsAction",
      }),
      onClick: onClickDetails,
    });
    if (loginType !== LOGIN_TYPE_ADMLIMITED) {
      itemsAction.push({
        label: intl.formatMessage({
          id: "Load.FileImportStatus.DownloadAction",
        }),
        onClick: onClickDownload,
      });
    }
    itemsAction.push({
      onClick: onClickDelete,
      label: intl.formatMessage({
        id: "Load.FileImportStatus.DeleteAction",
      }),
    });
    return itemsAction;
  }

  const handleChangeCheckbox = () => {
    void toggleSelectRecipient(item.Id);
  };

  return (
    <DataListRow>
      <Grid cols={12}>
        <GridCell span={1}>
          <Checkbox
            value={item.Id}
            checked={checked}
            disabled={disabled}
            onChange={handleChangeCheckbox}
          />
        </GridCell>
        <GridCell span={3}>
          <Text variant="light">
            <TruncateAndTooltip text={item.Filename} />
          </Text>
        </GridCell>
        <GridCell span={1}>
          <Text variant="light">{intl.formatNumber(item.NumberOfRows)}</Text>
        </GridCell>
        <GridCell span={3}>
          {!item.Groups || item.Groups.length === 0 ? (
            <Text variant="light">-</Text>
          ) : (
            item.Groups.map((group: string) => (
              <Text key={group} variant="light">
                <TruncateAndTooltip text={group} />
              </Text>
            ))
          )}
        </GridCell>
        <GridCell span={2}>
          <Text variant="light">
            {item.StartDate
              ? fromUTCtoZoneFormatted(
                  item.StartDate,
                  TimeZoneCode,
                  "YYYY-MM-DD HH:mm",
                )
              : "-"}
          </Text>
        </GridCell>
        <GridCell span={2}>
          <Badge
            text={intl.formatMessage({
              id:
                item.Status === 3
                  ? "Load.FileImportStatus.CompleteStatus"
                  : "Load.FileImportStatus.ErrorStatus",
            })}
            type={item.Status === 3 ? "success" : "error"}
          />
        </GridCell>
      </Grid>
      <DataListExtraColumn after width={EXTRA_COLUMN_AFTER_WIDTH}>
        <Actions items={setItemsAction()} />
      </DataListExtraColumn>
    </DataListRow>
  );
};

export default ImportedTableRow;
